import { DictionariesListPage } from 'features/dictionaries/components/DictionariesListPage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesEquipmentPage = () => {
  return <DictionariesListPage type={DictionaryType.Equipment} />
}
